import type { HttpClient } from '@wix/http-client'
import {
  getItemPageSeoSchema,
  saveItemPageSeoSchema,
} from '../itemPageSeoSchema'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

interface Params {
  httpClient: HttpClient
  editorSdkProxy: EditorSDK
  oldPageRef: PageRef
  newPageRef: PageRef
  isListPage: boolean
}

export const duplicateSeoSchema = async ({
  httpClient,
  editorSdkProxy,
  oldPageRef,
  newPageRef,
  isListPage,
}: Params): Promise<void> => {
  if (isListPage) {
    const { advancedSeoData } = await editorSdkProxy.document.pages.data.get({
      pageRef: oldPageRef,
    })
    await editorSdkProxy.document.pages.data.update({
      pageRef: newPageRef,
      data: { advancedSeoData },
    })
  } else {
    const seoSchema = await getItemPageSeoSchema({
      httpClient,
      pageId: oldPageRef.id,
    })
    if (seoSchema) {
      await saveItemPageSeoSchema({
        httpClient,
        pageId: newPageRef.id,
        seoSchema,
      })
    }
  }
}
